/**
 * @module app.cd
 */

import { bindingMode, autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IHouseholdSearchFilters } from "app/cd/services/household-service";

@autoinject
export class HouseholdFilters extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.twoWay })
    public searchFilters: IHouseholdSearchFilters = {};

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////


}
